
export default {
    success: 'Your Prior Authorization request has been submitted successfully!',
    getAuthTitle: (authNumber) => `Authorization Number: ${authNumber}`
}